// Window style configuration types and data

// Define the window style configuration type
export interface WindowStyleConfig {
  id: number;
  name: string;
  category: 'traditional' | 'heritage' | 'topHung' | 'fixed' | 'sideHung' | 'tiltAndTurn' | 'slidingSash' | 'bespoke';
  previewPath?: string;
  emailPath?: string;
  imagePath?: string;
  description?: string;
}

// Initialize the window styles array
export const WINDOW_STYLES: WindowStyleConfig[] = [
  {
    "id": 1,
    "name": "Fixed  Double  Landscape",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double Landscape.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double Landscape.jpg",
    "description": "Auto-generated from Fixed  Double  Landscape"
  },
  {
    "id": 2,
    "name": "Fixed  Double &  Fixed  Fans",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double & Fixed Fans.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double & Fixed Fans.jpg",
    "description": "Auto-generated from Fixed  Double &  Fixed  Fans"
  },
  {
    "id": 3,
    "name": "Fixed  Fan  Light",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Fan Light.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Fan Light.jpg",
    "description": "Auto-generated from Fixed  Fan  Light"
  },
  {
    "id": 4,
    "name": "Fixed  Double  Portrait",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double Portrait.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double Portrait.jpg",
    "description": "Auto-generated from Fixed  Double  Portrait"
  },
  {
    "id": 5,
    "name": "Single  Fixed",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Single Fixed.jpg",
    "emailPath": "images/windows/Casements/Fixed/Single Fixed.jpg",
    "description": "Auto-generated from Single  Fixed"
  },
  {
    "id": 6,
    "name": "Double  Bottom  Opener",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Double Bottom Opener.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Double Bottom Opener.jpg",
    "description": "Auto-generated from Double  Bottom  Opener"
  },
  {
    "id": 7,
    "name": "Fixed  Triple  Landscape",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Triple Landscape.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Triple Landscape.jpg",
    "description": "Auto-generated from Fixed  Triple  Landscape"
  },
  {
    "id": 8,
    "name": "Button  Opener  Fixed  Fan",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Button Opener Fixed Fan.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Button Opener Fixed Fan.jpg",
    "description": "Auto-generated from Button  Opener  Fixed  Fan"
  },
  {
    "id": 9,
    "name": "Fan &  Bottom  Opener",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Fan & Bottom Opener.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Fan & Bottom Opener.jpg",
    "description": "Auto-generated from Fan &  Bottom  Opener"
  },
  {
    "id": 10,
    "name": "Double  Fan  Opener    Fixed  Full  Width",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Double Fan Opener - Fixed Full Width.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Double Fan Opener - Fixed Full Width.jpg",
    "description": "Auto-generated from Double  Fan  Opener    Fixed  Full  Width"
  },
  {
    "id": 11,
    "name": "Left  Botom  Opener  Traditional",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Left Botom Opener Traditional.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Left Botom Opener Traditional.jpg",
    "description": "Auto-generated from Left  Botom  Opener  Traditional"
  },
  {
    "id": 12,
    "name": "Fan  Light  Opener  Only",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Fan Light Opener Only.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Fan Light Opener Only.jpg",
    "description": "Auto-generated from Fan  Light  Opener  Only"
  },
  {
    "id": 13,
    "name": "Fixed  Triple  Portrait",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Triple Portrait.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Triple Portrait.jpg",
    "description": "Auto-generated from Fixed  Triple  Portrait"
  },
  {
    "id": 14,
    "name": "Left  Bottom  Openers    Fixed  Large  Right",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Left Bottom Openers - Fixed Large Right.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Left Bottom Openers - Fixed Large Right.jpg",
    "description": "Auto-generated from Left  Bottom  Openers    Fixed  Large  Right"
  },
  {
    "id": 15,
    "name": "Double  Fan  Opener    Fixed  Split",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Double Fan Opener - Fixed Split.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Double Fan Opener - Fixed Split.jpg",
    "description": "Auto-generated from Double  Fan  Opener    Fixed  Split"
  },
  {
    "id": 16,
    "name": "Left  Bottom  Openers    Right  Fixed",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Left Bottom Openers - Right Fixed.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Left Bottom Openers - Right Fixed.jpg",
    "description": "Auto-generated from Left  Bottom  Openers    Right  Fixed"
  },
  {
    "id": 17,
    "name": "Left  Bottom  Opener    Fixed  Right",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Left Bottom Opener - Fixed Right.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Left Bottom Opener - Fixed Right.jpg",
    "description": "Auto-generated from Left  Bottom  Opener    Fixed  Right"
  },
  {
    "id": 18,
    "name": "Right  Bottom  Opener    Fixed  Left",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Right Bottom Opener - Fixed Left.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Right Bottom Opener - Fixed Left.jpg",
    "description": "Auto-generated from Right  Bottom  Opener    Fixed  Left"
  },
  {
    "id": 19,
    "name": "Right  Bottom  Opener  Traditional",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Right Bottom Opener Traditional.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Right Bottom Opener Traditional.jpg",
    "description": "Auto-generated from Right  Bottom  Opener  Traditional"
  },
  {
    "id": 20,
    "name": "Middle  Bottom  Openers    Triple  Section",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Middle Bottom Openers - Triple Section.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Middle Bottom Openers - Triple Section.jpg",
    "description": "Auto-generated from Middle  Bottom  Openers    Triple  Section"
  },
  {
    "id": 21,
    "name": "Right  Bottom  Openers    Fixed  Large  Left",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Right Bottom Openers - Fixed Large Left.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Right Bottom Openers - Fixed Large Left.jpg",
    "description": "Auto-generated from Right  Bottom  Openers    Fixed  Large  Left"
  },
  {
    "id": 22,
    "name": "Middle  Bottom  Opener",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Middle Bottom Opener.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Middle Bottom Opener.jpg",
    "description": "Auto-generated from Middle  Bottom  Opener"
  },
  {
    "id": 23,
    "name": "Single  Fan  Top  Left    Triple  Section",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Fan Top Left - Triple Section.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Fan Top Left - Triple Section.jpg",
    "description": "Auto-generated from Single  Fan  Top  Left    Triple  Section"
  },
  {
    "id": 24,
    "name": "Single  Fan  Top  Left",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Fan Top Left.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Fan Top Left.jpg",
    "description": "Auto-generated from Single  Fan  Top  Left"
  },
  {
    "id": 25,
    "name": "Single  Full  Opener",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Full Opener.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Full Opener.jpg",
    "description": "Auto-generated from Single  Full  Opener"
  },
  {
    "id": 26,
    "name": "Single  Fan  Top  Right    Triple  Section",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Fan Top Right - Triple Section.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Fan Top Right - Triple Section.jpg",
    "description": "Auto-generated from Single  Fan  Top  Right    Triple  Section"
  },
  {
    "id": 27,
    "name": "Single  Fan  Top  Middle    Triple  Section",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Fan Top Middle - Triple Section.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Fan Top Middle - Triple Section.jpg",
    "description": "Auto-generated from Single  Fan  Top  Middle    Triple  Section"
  },
  {
    "id": 28,
    "name": "Single  Fan  Top  Right",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Single Fan Top Right.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Single Fan Top Right.jpg",
    "description": "Auto-generated from Single  Fan  Top  Right"
  },
  {
    "id": 29,
    "name": "Traditional  Style  Bottom  Openers",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Traditional Style Bottom Openers.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Traditional Style Bottom Openers.jpg",
    "description": "Auto-generated from Traditional  Style  Bottom  Openers"
  },
  {
    "id": 30,
    "name": "Right  Bottom  Openers    Left  Fixed",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Right Bottom Openers - Left Fixed.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Right Bottom Openers - Left Fixed.jpg",
    "description": "Auto-generated from Right  Bottom  Openers    Left  Fixed"
  },
  {
    "id": 31,
    "name": "Traditional  Style  Three    Bottom  Opener",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Traditional Style Three - Bottom Opener.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Traditional Style Three - Bottom Opener.jpg",
    "description": "Auto-generated from Traditional  Style  Three    Bottom  Opener"
  },
  {
    "id": 32,
    "name": "Double  Casement",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Double Casement.jpg",
    "emailPath": "images/windows/Casements/Traditional/Double Casement.jpg",
    "description": "Auto-generated from Double  Casement"
  },
  {
    "id": 33,
    "name": "Left  Hung  Traditional",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Left Hung Traditional.jpg",
    "emailPath": "images/windows/Casements/Traditional/Left Hung Traditional.jpg",
    "description": "Auto-generated from Left  Hung  Traditional"
  },
  {
    "id": 34,
    "name": "Left  Side  Hung  Opener",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Left Side Hung Opener.jpg",
    "emailPath": "images/windows/Casements/Traditional/Left Side Hung Opener.jpg",
    "description": "Auto-generated from Left  Side  Hung  Opener"
  },
  {
    "id": 35,
    "name": "Triple  Fan  Openers",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Triple Fan Openers.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Triple Fan Openers.jpg",
    "description": "Auto-generated from Triple  Fan  Openers"
  },
  {
    "id": 36,
    "name": "Right  Side  Hung  Opener",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Right Side Hung Opener.jpg",
    "emailPath": "images/windows/Casements/Traditional/Right Side Hung Opener.jpg",
    "description": "Auto-generated from Right  Side  Hung  Opener"
  },
  {
    "id": 37,
    "name": "Traditional  Style  Two    Bottom  Openers",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Traditional Style Two - Bottom Openers.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Traditional Style Two - Bottom Openers.jpg",
    "description": "Auto-generated from Traditional  Style  Two    Bottom  Openers"
  },
  {
    "id": 38,
    "name": "Middle  Opener    Triple  Section  Two",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Middle Opener - Triple Section Two.jpg",
    "emailPath": "images/windows/Casements/Traditional/Middle Opener - Triple Section Two.jpg",
    "description": "Auto-generated from Middle  Opener    Triple  Section  Two"
  },
  {
    "id": 39,
    "name": "Left  Side  Hung",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Left Side-Hung.jpg",
    "emailPath": "images/windows/Casements/Traditional/Left Side-Hung.jpg",
    "description": "Auto-generated from Left  Side  Hung"
  },
  {
    "id": 40,
    "name": "Middle  Opener    Triple  Section  One",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Middle Opener - Triple Section One.jpg",
    "emailPath": "images/windows/Casements/Traditional/Middle Opener - Triple Section One.jpg",
    "description": "Auto-generated from Middle  Opener    Triple  Section  One"
  },
  {
    "id": 41,
    "name": "Right  Hung  Traditional",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Right Hung Traditional.jpg",
    "emailPath": "images/windows/Casements/Traditional/Right Hung Traditional.jpg",
    "description": "Auto-generated from Right  Hung  Traditional"
  },
  {
    "id": 42,
    "name": "Traditional  Right  Large  Fixed  Pane",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Right Large Fixed Pane.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Right Large Fixed Pane.jpg",
    "description": "Auto-generated from Traditional  Right  Large  Fixed  Pane"
  },
  {
    "id": 43,
    "name": "Right  Side  Hung",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Right-Side Hung.jpg",
    "emailPath": "images/windows/Casements/Traditional/Right-Side Hung.jpg",
    "description": "Auto-generated from Right  Side  Hung"
  },
  {
    "id": 44,
    "name": "Traditional  Style  Five",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Five.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Five.jpg",
    "description": "Auto-generated from Traditional  Style  Five"
  },
  {
    "id": 45,
    "name": "Traditional  Left  Large  Fixed  Pane",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Left Large Fixed Pane.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Left Large Fixed Pane.jpg",
    "description": "Auto-generated from Traditional  Left  Large  Fixed  Pane"
  },
  {
    "id": 46,
    "name": "Left  &  Right  Opener    Triple  Section  One",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Left & Right Opener - Triple Section One.jpg",
    "emailPath": "images/windows/Casements/Traditional/Left & Right Opener - Triple Section One.jpg",
    "description": "Auto-generated from Left  &  Right  Opener    Triple  Section  One"
  },
  {
    "id": 47,
    "name": "Traditional  Style  Four    Bottom  Openers",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Four - Bottom Openers.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Four - Bottom Openers.jpg",
    "description": "Auto-generated from Traditional  Style  Four    Bottom  Openers"
  },
  {
    "id": 48,
    "name": "Traditional  Style  One",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style One.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style One.jpg",
    "description": "Auto-generated from Traditional  Style  One"
  },
  {
    "id": 49,
    "name": "Traditional  Style  Four",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Four.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Four.jpg",
    "description": "Auto-generated from Traditional  Style  Four"
  },
  {
    "id": 2001,
    "name": "Traditional  Style  4  Column  One",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style 4 Column One.png",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style 4 Column One.png",
    "description": "Auto-generated from Traditional  Style  4  Column  One"
  },
  {
    "id": 2002,
    "name": "Traditional  Style  4  Column  Two",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Two.png",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Two.png",
    "description": "Auto-generated from Traditional  Style  4  Column  Two"
  },
  {
    "id": 2003,
    "name": "Traditional  Style  4  Column  Three",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Three.png",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Three.png",
    "description": "Auto-generated from Traditional  Style  4  Column  Three"
  },
  {
    "id": 2004,
    "name": "Traditional  Style  4  Column  Four",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Four.png",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style 4 Column Four.png",
    "description": "Auto-generated from Traditional  Style  4  Column  Four"
  },
  {
    "id": 50,
    "name": "Traditional  Style  Six",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Six.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Six.jpg",
    "description": "Auto-generated from Traditional  Style  Six"
  },
  {
    "id": 51,
    "name": "Traditional  Style  Three",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Three.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Three.jpg",
    "description": "Auto-generated from Traditional  Style  Three"
  },
  {
    "id": 52,
    "name": "Traditional  Style  Two",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Traditional Style Two.jpg",
    "emailPath": "images/windows/Casements/Traditional/Traditional Style Two.jpg",
    "description": "Auto-generated from Traditional  Style  Two"
  },
  {
    "id": 53,
    "name": "Fixed  Double &  Fixed  Fans",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double & Fixed Fans.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double & Fixed Fans.jpg",
    "description": "Auto-generated from Fixed  Double &  Fixed  Fans"
  },
  {
    "id": 54,
    "name": "Fixed  Double  Portrait",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double Portrait.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double Portrait.jpg",
    "description": "Auto-generated from Fixed  Double  Portrait"
  },
  {
    "id": 55,
    "name": "Fixed  Double  Landscape",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Fixed Double Landscape.jpg",
    "emailPath": "images/windows/Casements/Fixed/Fixed Double Landscape.jpg",
    "description": "Auto-generated from Fixed  Double  Landscape"
  },
  {
    "id": 56,
    "name": "Quad  Casement",
    "category": "traditional",
    "previewPath": "images/windows/Casements/Traditional/Quad Casement.jpg",
    "emailPath": "images/windows/Casements/Traditional/Quad Casement.jpg",
    "description": "Auto-generated from Quad  Casement"
  },
  {
    "id": 57,
    "name": "Quad  Fixed",
    "category": "fixed",
    "previewPath": "images/windows/Casements/Fixed/Quad Fixed.jpg",
    "emailPath": "images/windows/Casements/Fixed/Quad Fixed.jpg",
    "description": "Auto-generated from Quad  Fixed"
  },
  {
    "id": 1001,
    "name": 'Button Opener Fixed Fan',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Button Opener Fixed Fan.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Button Opener Fixed Fan.jpg',
    "description": 'Tilt & Turn - Button Opener Fixed Fan'
  },
  {
    "id": 1002,
    "name": 'Single Full Opener',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Single Full Opener.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Single Full Opener.jpg',
    "description": 'Tilt & Turn - Single Full Opener'
  },
  {
    "id": 1003,
    "name": 'Left Side-Hung',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Left Side-Hung.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Left Side-Hung.jpg',
    "description": 'Tilt & Turn - Left Side-Hung'
  },
  {
    "id": 1004,
    "name": 'Right-Side Hung',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Right-Side Hung.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Right-Side Hung.jpg',
    "description": 'Tilt & Turn - Right-Side Hung'
  },
  {
    "id": 1005,
    "name": 'Middle Opener - Triple Section One',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Middle Opener - Triple Section One.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Middle Opener - Triple Section One.jpg',
    "description": 'Tilt & Turn - Middle Opener - Triple Section One'
  },
  {
    "id": 1006,
    "name": 'Middle Bottom Opener',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Middle Bottom Opener.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Middle Bottom Opener.jpg',
    "description": 'Tilt & Turn - Middle Bottom Opener'
  },
  {
    "id": 1007,
    "name": 'Double Casement',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Double Casement.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Double Casement.jpg',
    "description": 'Tilt & Turn - Double Casement'
  },
  {
    "id": 1008,
    "name": 'Traditional Style Bottom Openers',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Traditional Style Bottom Openers.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Traditional Style Bottom Openers.jpg',
    "description": 'Tilt & Turn - Traditional Style Bottom Openers'
  },
  {
    "id": 1009,
    "name": 'Quad Casement',
    "category": 'tiltAndTurn',
    "previewPath": 'images/windows/TiltAndTurn/Quad Casement.jpg',
    "emailPath": 'images/windows/TiltAndTurn/Quad Casement.jpg',
    "description": 'Tilt & Turn - Quad Casement'
  },
  {
    "id": 1010,
    "name": "Square  Openers  One",
    "category": "topHung",
    "previewPath": "images/windows/Casements/Top-Hung/Square Openers One.jpg",
    "emailPath": "images/windows/Casements/Top-Hung/Square Openers One.jpg",
    "description": "Auto-generated from Square  Openers  One"
  },
  {
    "id": 1011,
    "name": "Door Style 1 - Glazed",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-1/lh/glazed/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-1/lh/glazed/handle-chrome.png",
    "description": "uPVC Door - Style 1 (Glazed)"
  },
  {
    "id": 1012,
    "name": "Door Style 1 - Panel",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-1/lh/panel/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-1/lh/panel/handle-chrome.png",
    "description": "uPVC Door - Style 1 (Panel)"
  },
  {
    "id": 1013,
    "name": "Door Style 2 - Glazed",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-2/lh/glazed/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-2/lh/glazed/handle-chrome.png",
    "description": "uPVC Door - Style 2 (Glazed)"
  },
  {
    "id": 1014,
    "name": "Door Style 2 - Panel",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-2/lh/panel/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-2/lh/panel/handle-chrome.png",
    "description": "uPVC Door - Style 2 (Panel)"
  },
  {
    "id": 1015,
    "name": "Door Style 4 - Glazed",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-4/lh/glazed/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-4/lh/glazed/handle-chrome.png",
    "description": "uPVC Door - Style 4 (Glazed)"
  },
  {
    "id": 1016,
    "name": "Door Style 4 - Panel",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-4/lh/panel/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-4/lh/panel/handle-chrome.png",
    "description": "uPVC Door - Style 4 (Panel)"
  },
  {
    "id": 1017,
    "name": "Door Style 5 - Glazed",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-5/lh/glazed/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-5/lh/glazed/handle-chrome.png",
    "description": "uPVC Door - Style 5 (Glazed)"
  },
  {
    "id": 1018,
    "name": "Door Style 5 - Panel",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-5/lh/panel/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-5/lh/panel/handle-chrome.png",
    "description": "uPVC Door - Style 5 (Panel)"
  },
  {
    "id": 1019,
    "name": "Door Style 6 - Glazed",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-6/glazed/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-6/glazed/handle-chrome.png",
    "description": "uPVC Door - Style 6 (Glazed)"
  },
  {
    "id": 1020,
    "name": "Door Style 6 - Panel",
    "category": "bespoke",
    "previewPath": "images/windows/Doors/uPVC/style-6/panel/handle-chrome.png",
    "emailPath": "images/windows/Doors/uPVC/style-6/panel/handle-chrome.png",
    "description": "uPVC Door - Style 6 (Panel)"
  }
];

// Helper function to add a new window style
export function addNewStyle(style: Omit<WindowStyleConfig, 'id'>): WindowStyleConfig {
  const maxId = Math.max(0, ...WINDOW_STYLES.map((s: WindowStyleConfig) => s.id));
  const newStyle: WindowStyleConfig = {
    id: maxId + 1,
    ...style
  };
  WINDOW_STYLES.push(newStyle);
  return newStyle;
}

// Helper function to update an existing style
export function updateStyle(id: number, updates: Partial<WindowStyleConfig>): WindowStyleConfig | null {
  const index = WINDOW_STYLES.findIndex((s: WindowStyleConfig) => s.id === id);
  if (index === -1) return null;
  
  WINDOW_STYLES[index] = {
    ...WINDOW_STYLES[index],
    ...updates
  };
  return WINDOW_STYLES[index];
}

// Helper function to remove a style
export function removeStyle(id: number): boolean {
  const index = WINDOW_STYLES.findIndex((s: WindowStyleConfig) => s.id === id);
  if (index === -1) return false;
  
  WINDOW_STYLES.splice(index, 1);
  return true;
}

// Helper function to get a style by ID
export function getStyleById(id: number): WindowStyleConfig | null {
  return WINDOW_STYLES.find((s: WindowStyleConfig) => s.id === id) || null;
}

// Initialize window styles by type
export const windowStylesByType: Record<string, WindowStyleConfig[]> = {
  'casement': WINDOW_STYLES.filter((style: WindowStyleConfig) => 
    style.category === 'traditional' || 
    style.category === 'topHung' || 
    style.category === 'fixed'
  ),
  'flush-casement': WINDOW_STYLES.filter((style: WindowStyleConfig) => 
    style.category === 'traditional' || 
    style.category === 'topHung' || 
    style.category === 'fixed'
  ),
  'aluminium': WINDOW_STYLES.filter((style: WindowStyleConfig) => 
    style.category === 'traditional' || 
    style.category === 'topHung' || 
    style.category === 'fixed'
  ),
  // Timber uses the same image-bank categories as casement for v1
  'timber': WINDOW_STYLES.filter((style: WindowStyleConfig) =>
    style.category === 'traditional' ||
    style.category === 'topHung' ||
    style.category === 'fixed'
  ),
  'tilt-and-turn': WINDOW_STYLES.filter((style: WindowStyleConfig) => style.category === 'tiltAndTurn'),
  'sliding-sash': WINDOW_STYLES.filter((style: WindowStyleConfig) => 
    style.category === 'slidingSash'
  ),
  // uPVC doors: v1 uses bespoke bucket until we add dedicated door style metadata.
  // This keeps the Quote Visual Designer working without breaking existing filters.
  'upvc-door': WINDOW_STYLES.filter((style: WindowStyleConfig) => style.category === 'bespoke')
};